import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { GET_URL } from '..';
import { getS3url } from '../utilities/s3CacheHelper';
export const useGetS3Url = ({ s3Key, preview }) => {
    const { refetch } = useQuery(GET_URL, {
        variables: { input: { s3Key: '', preview } },
        skip: true,
    });
    const [s3Url, setS3Url] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        (async () => {
            if (s3Key) {
                setLoading(true);
                setError('');
                const s3Url = await getS3url(s3Key, preview ?? false, async (s3Key) => {
                    try {
                        const result = await refetch({ input: { s3Key, preview } });
                        return result.data.getUrl;
                    }
                    catch (err) {
                        setError('Error fetching document');
                        return '';
                    }
                });
                setLoading(false);
                setS3Url(s3Url);
            }
        })();
    }, [refetch, s3Key, preview]);
    return { s3Url, loading, error };
};
